module.exports = __webpack_public_path__ + "img/about-chat.cea797d.png";